import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { ref: "mapContainer" }
const _hoisted_2 = { ref: "mapRef" }
const _hoisted_3 = { class: "state" }
const _hoisted_4 = { class: "rate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, null, 512)),
    (_ctx.showPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(_ctx.style)
        }, [
          (_ctx.showClose)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup  && _ctx.closePopup (...args)))
              }, "X"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.popupState), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.popupRate), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 512))
}